const GetTrangThaiDonTheoDonVi = (trangThaiDonInfo) => {

  let trangThaiDon = {};

  if (trangThaiDonInfo && localStorage.getItem('userInfo')) {

    let data = JSON.parse(localStorage.getItem('userInfo'));

    trangThaiDonInfo.map((item) => {
      if (item.donViId == data.donViId){
        trangThaiDon = item;
      }
    })
  }
  return trangThaiDon;
}

export { GetTrangThaiDonTheoDonVi };


// WEBPACK FOOTER //
// ./src/components/modules/login/GetTrangThaiDonTheoDonVi.js